import React from "react";
import { debounce } from "lodash";

import { CustomFormattedMessage } from "@src/utility/context/CustomFormattedMessage";
import AppButton from "@vcomponents/AppButton";
import { toggleChevronIcon } from "@src/assets/images/svgs";

import { pagination } from "./data";

import "./style.scss";
import { observer } from "mobx-react-lite";

/**
 * TICKETS TABLE PAGINATION
 * @param {Object} props
 * @param {Object} props.table
 * @returns
 */
const Pagination = observer((props) => {
  const { table } = props;
  const [pageIndex, setPageIndex] = React.useState(
    table.getState()?.pagination?.pageIndex + 1
  );

  const setPageIndexOnInputChange = React.useCallback(
    (payload) => {
      const value = payload.target.value;
      if (value <= table.pageCount && value >= 0) {
        setPageIndex(value);
        tablePageIndexUpdataCall(value);
      }
    },
    [table.pageCount]
  );
  const tablePageIndexUpdataCall = debounce((e) => {
    table.setPageIndex(e - 1);
  }, 2000);

  React.useEffect(() => {
    setPageIndex(table.getState()?.pagination?.pageIndex + 1);
  }, [table?.getState()?.pagination?.pageIndex]);

  return (
    <div className="tickets-pagination">
      <div className="pagination-actions">
        <div className="pagination-actions__perPageToggle">
          <label htmlFor="perPageToggler">
            <CustomFormattedMessage
              id={"Rows per page:"}
              defaultMessage={"Rows per page:"}
            />
          </label>
          <select
            id="perPageToggler"
            value={table.getState().pagination.pageSize}
            onChange={(e) => {
              table.setPageSize(Number(e.target.value));
            }}
          >
            {pagination.rowsPerPage.map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </div>
        <div className="pagination-actions__navigation">
          <AppButton
            icon={toggleChevronIcon}
            onClick={table.previousPage}
            disabled={!table.getCanPreviousPage() || !table.pageCount}
          />

          <span className="page-info">
            <input
              type="number"
              min={1}
              onChange={setPageIndexOnInputChange}
              value={pageIndex}
            />
            <span>/{table.pageCount}</span>
          </span>
          <AppButton
            icon={toggleChevronIcon}
            onClick={table.nextPage}
            disabled={
              table.getState().pagination.pageIndex + 1 === table.pageCount ||
              !table.pageCount
            }
          />
        </div>
      </div>
    </div>
  );
});

export default Pagination;
